export default "__VITE_ASSET__eqXVyeCu__"